import { render, staticRenderFns } from "./createTask.vue?vue&type=template&id=10afcdf3"
import script from "./createTask.vue?vue&type=script&lang=js"
export * from "./createTask.vue?vue&type=script&lang=js"
import style0 from "./createTask.vue?vue&type=style&index=0&id=10afcdf3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports